import { ParentContext } from 'global/cnr/contexts/ParentContext';
import _ from 'lodash';
import React, { useContext, useEffect, useReducer } from 'react';
import { AppComponentContext } from '../../../../global/cnr/contexts/AppComponentContext';
import { DatabaseContext } from '../../../../global/cnr/contexts/DatabaseContext';
import { NavigationContext } from '../../../../global/cnr/contexts/NavigationContext';
import { createAppStaticViews } from '../../../../global/firestoreData/staticViews/updateStaticViews';
import { golfTournamentHandlers, golfTournamentInitialState, golfTournamentReducer } from '../reducers/GolfTournamentReducer';
import { createRefPath, createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { _currentUserIdProp } from 'global/cnr/reducers/AppUserReducer';

const _updatePlayerRecords = false;


export const GolfTournamentContext = React.createContext()

/**
 * @provides teams 
 * @provides golfCourse  
 * @provides holes 
 * @provides golfMatchData  
 * @provides roundsStatus 
 * @provides golfTournament_handlers 
 * @provides golfTeam1
 * @provides golfTeam2
 * @provides golfTeam1Style
 * @provides golfTeam2Style
 */

const GolfTournamentProvider = (props) => {

  const { golfTournamentKey, golfTournament: golfTournament_fromList } = props ?? {}

  // golfParentContext 
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, currentSettings_state } = states ?? {}

  const { aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  // papsContext
  const navigationContext = useContext(NavigationContext)
  const { navigation_fns } = navigationContext ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // papsContext 
  const { pathViews, viewKey } = paps_state ?? {}

  // let viParentKey;
  let viSubKeys;

  if (aps_viewItems) {
    Object.keys(aps_viewItems).forEach(viKey => {
      const { dataConnection } = aps_viewItems[viKey]
      const { startParentData, startDataPages } = dataConnection ?? {}
      if (startParentData) {
        // viParentKey = viKey
        viSubKeys = startDataPages
      }
    })
  }

  // golfEventContext
  const golfEventContext = useContext(AppComponentContext)
  const { golfEvent_state } = golfEventContext ?? {}
  const { golfTournaments } = golfEvent_state ?? {}

  // local state  
  const init_state = { pathViews, database_fns, navigation_fns, viewKey, golfEvent_state }
  const [golfTournament_state, golfTournament_dispatch] = useReducer(golfTournamentReducer, init_state, golfTournamentInitialState)
  const golfTournament_handlers = golfTournamentHandlers(golfTournament_dispatch, golfTournament_state)
  const { golfTournament, golfCourse, matches, details, roundsStatus, golferRecords, showWizard } = golfTournament_state ?? golfTournament_state
  const { allowTempAccess } = golfTournament ?? {}
  const { rounds: rounds_details, teams: teams_details, lineups: lineups_details, golfers } = details ?? {}
  const { holes } = golfCourse ?? {}

  useEffect(
    () => {
      if (golferRecords) {
        const partners = {}
        _.forEach(golferRecords, (gr, grKey) => {
          partners[grKey] = gr?.partners
        })
        if (_updatePlayerRecords) {
          const ref = createRefPath_event(pathViews, ['golfer_partners', golfTournament.id])
          database_fns.doc_set(ref, partners, true)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [golferRecords]
  )

  useEffect(
    () => {
      if (allowTempAccess) {
        const cb = (res) => {
          golfTournament_handlers.handleAmmend_tempAppUserAccess(res)
        }
        const refPath = createRefPath(['_accessTemp', golfTournament.id])
        database_fns.get_doc({ refPath, callback: cb, opts: { ignoreId: true } })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [allowTempAccess]
  )

  useEffect(() => {
    if (pathViews.golfTournaments) {
      const gt = golfTournaments && golfTournaments[pathViews.golfTournaments] ? golfTournaments[pathViews.golfTournaments] : null
      golfTournament_handlers.handleGet_golfTournamentData()
    } else if (golfTournamentKey) {
      golfTournament_handlers.handleGet_golfTournamentData(null, golfTournamentKey)
    } else if (golfTournament_fromList) {
      const gtl = golfTournaments && golfTournaments[golfTournament_fromList] ? golfTournaments[golfTournament_fromList] : null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (golfTournament && rounds_details && teams_details && golfCourse) {
      golfTournament_handlers.handleSet_initGolfTournament()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [golfTournament, rounds_details, golfCourse, teams_details, pathViews.golfTournaments]);

  useEffect(() => {
    if (matches) {
      golfTournament_handlers.handleSet_golfDataMatches(matches)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [matches]);

  useEffect(
    () => {
      if (matches && golfers) {
        golfTournament_handlers.handleSet_golferRoundMatches()
      }
      // if (updateStuff3) { golfTournament_handlers.handleFix_golfTournamentFromMatches(matches) }
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [matches, golfers]
  )

  // useEffect(
  //   () => {
  //     // if (updateStuff) { golfTournament_handlers.handleFix_golfTournament() }
  //     // if (updateStuff2) { golfTournament_handlers.handleFix_golfersTournamentHandicaps() }
  //     // if (updateStuff3) { golfTournament_handlers.handleFix_golfersTournament() } 
  //     // eslint-disable-next-line react-hooks/exhaustive-deps  
  //   }, [golfers]
  // )

  // useEffect(
  //   () => {
  //     // if (updateStuff3) { golfTournament_handlers.handleFix_golfTournamentFromMatches(matches) }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps  
  //   }, [matches]
  // )

  if (golfTournament && rounds_details && teams_details && lineups_details && roundsStatus) {
    const appStaticViews = createAppStaticViews(golfTournament_state, viSubKeys, aps_viewItems)
    return <GolfTournamentContext.Provider value={{ golfTournament_handlers, golfTournament_state, appStaticViews }}>
      {props.children}
    </GolfTournamentContext.Provider>
  } else {
    return <GolfTournamentContext.Provider value={{ golfTournament_handlers, golfTournament_state }}>
      {props.children}
    </GolfTournamentContext.Provider>
  }
};

export default GolfTournamentProvider